<template>
<div class="media-detail-container">
  <div class="media-detail-content">
    <img :src="src"/>
  </div>
  <div class="media-detail-info"></div>
</div>
</template>
<script>
import { mapMutations } from 'vuex'
import { getMediaFileDetail } from '@/api/data'
export default {
  name: 'FileDetail',
  props: {
    media: {
      type: Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      src: ''
    }
  },
  mounted () {
    this.loadPage()
  },
  methods: {
    ...mapMutations([
      'setTagNavSubtitle'
    ]),
    loadPage () {
      let _this = this
      getMediaFileDetail(this.$route.params.id).then(resp => {
        if (!resp.data.ok) {
          _this.$Notice.error({ title: '获取媒体文件详情失败', desc: resp.data.msg })
        } else {
          _this.setTagNavSubtitle({ route: this.$route, subtitle: resp.data.data.filename })
          _this.src = resp.data.data.url
        }
      })
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.path !== from.path) {
        this.loadPage()
      }
    }
  }
}
</script>
<style scoped>
.media-detail-container {
  display: flex;
  height: 100%;
  flex-direction: row;
}
.media-detail-content {
  display: flex;
  width: 70%;
  height: 100%;
  background-color: #eee;
  margin: 10px;
}
.media-detail-container img, .media-detail-container video {
  display: block;
  height: fit-content !important;
  max-width: 61.8%;
  max-height: 95%;
  margin: auto;
}
.media-detail-info {
  display: flex;
  width: 30%;
  height: 100%;
  background-color: #eee;
  margin: 10px;
}
</style>
